import {
	PRODUCT_STOCK_GET,
	PRODUCT_STOCK_SUCCESS,
	TYPE_MOVEMENTS_SUCCESS,
	PRODUCT_MOVEMENT_CREATE_SUCCESS,
	PRODUCT_MOVEMENTS_GET,
	PRODUCT_MOVEMENTS_SUCCESS,
	PRODUCT_MOVEMENT_DELETE_SUCCESS,
	PRODUCT_PURCHASE_PRICE_SUCCESS,
	PRODUCT_PURCHASE_PRICE_SET_SUCCESS,
	PRODUCT_PURCHASE_PRICE_DELETE_SUCCESS,
	PRODUCT_PURCHASE_PRICE_BULK_SET_SUCCESS,
} from '../constants/productStock';

const initialState = {
	stocks: [],
	typeMovements: [],
	movements: [],
	movementsLoading: false,
	loading: false,
	// Keyed by id_product — the latest known HT purchase price for each
	// product visited this session (null once fetched but nothing found).
	purchasePrices: {},
};

export default function productStockReducer(state = initialState, action) {
	switch (action.type) {
		case PRODUCT_STOCK_GET:
			return { ...state, loading: true };
		case PRODUCT_STOCK_SUCCESS:
			return { ...state, loading: false, stocks: action.stocks };
		case TYPE_MOVEMENTS_SUCCESS:
			return { ...state, typeMovements: action.typeMovements };
		case PRODUCT_MOVEMENT_CREATE_SUCCESS:
			return {
				...state,
				stocks: state.stocks.map(s =>
					s.id_global === action.id_global
						? { ...s, pending_sum: Number(s.pending_sum) + Number(action.delta) }
						: s
				),
			};
		case PRODUCT_MOVEMENTS_GET:
			return { ...state, movementsLoading: true, movements: [] };
		case PRODUCT_MOVEMENTS_SUCCESS:
			return { ...state, movementsLoading: false, movements: action.movements };
		case PRODUCT_MOVEMENT_DELETE_SUCCESS:
			return {
				...state,
				movements: state.movements.filter(m => m.id !== action.id_movement),
			};
		case PRODUCT_PURCHASE_PRICE_SUCCESS:
			return {
				...state,
				purchasePrices: {
					...state.purchasePrices,
					[action.id_product]: action.unit_value,
				},
			};
		case PRODUCT_PURCHASE_PRICE_SET_SUCCESS:
		case PRODUCT_PURCHASE_PRICE_DELETE_SUCCESS:
			// Un prix enregistré pour une date d'effet postérieure au jour de
			// travail n'est pas encore le prix courant : on l'a bien écrit en
			// base, mais l'affichage ne doit pas bouger. Le drapeau est posé
			// par le saga (absent = on applique, cas de la suppression).
			if (action.applyToDisplay === false) {
				return state;
			}
			return {
				...state,
				purchasePrices: {
					...state.purchasePrices,
					[action.id_product]: action.unit_value,
				},
				stocks: state.stocks.map(s =>
					s.id_global === action.id_product
						? { ...s, purchase_price: action.unit_value }
						: s
				),
			};
		case PRODUCT_PURCHASE_PRICE_BULK_SET_SUCCESS: {
			const byId = {};
			action.items.forEach(item => {
				byId[item.id_product] = item.unit_value;
			});
			return {
				...state,
				purchasePrices: { ...state.purchasePrices, ...byId },
				stocks: state.stocks.map(s =>
					byId.hasOwnProperty(s.id_global)
						? { ...s, purchase_price: byId[s.id_global] }
						: s
				),
			};
		}
		default:
			return state;
	}
}
